export function createWelcomeMessage(welcomeMessage) {
  return {
    id: "welcome-message",
    text: welcomeMessage,
    user: {
      id: "ai_agent",
      name: "AI Assistant"
    },
    created_at: /* @__PURE__ */ new Date(),
    updated_at: /* @__PURE__ */ new Date(),
    status: "received",
    type: "system",
    html: welcomeMessage
  };
}
